import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebase/firebase";
import Header from "../components/Header";

// Icons from lucide-react
import {
  Dog,
  Gamepad2,
  BookOpenText,
  Video,
  Mic,
  Smile,
  Puzzle,
  Lock,
} from "lucide-react";

function Home() {
  const navigate = useNavigate();

  const categories = [
    { name: "Core Skills", path: "/core-skills", icon: <Dog className="w-6 h-6 text-blue-600" /> },
    { name: "Games & Activities", path: "/games", icon: <Gamepad2 className="w-6 h-6 text-blue-600" /> },
    { name: "Homemade Recipes", path: "/recipes", icon: <BookOpenText className="w-6 h-6 text-blue-600" /> },
    { name: "Video Library", path: "/videos", icon: <Video className="w-6 h-6 text-blue-600" /> },
    { name: "Podcast Library", path: "/podcasts", icon: <Mic className="w-6 h-6 text-blue-600" /> },
    { name: "Canine Body Language", path: "/body-language", icon: <Smile className="w-6 h-6 text-blue-600" /> },
    { name: "Enrichment", path: "/enrichment", icon: <Puzzle className="w-6 h-6 text-blue-600" /> },
    { name: "SA Resources 🔒", path: "/sa-resources", icon: <Lock className="w-6 h-6 text-blue-600" /> },
  ];

  const handleClick = (path) => {
    navigate(path);
  };

  const handleLogout = () => {
    signOut(auth).then(() => {
      navigate("/");
    });
  };

  return (
    <>
      <Header />
      <div className="min-h-screen bg-gray-50 px-6 py-10">
        <div className="flex flex-col sm:flex-row justify-between items-center mb-10">
          <div className="flex items-center gap-4">
            <img
              src="/paw-icon.png"
              alt="PTA Paw Logo"
              className="w-12 h-12 rounded-full border border-gray-300 shadow"
            />
            <div>
              <p className="text-xl font-semibold text-gray-800">Welcome back!</p>
              <p className="text-sm text-gray-500">Let’s dive into some training</p>
            </div>
          </div>
          <button
            onClick={handleLogout}
            className="mt-4 sm:mt-0 bg-red-600 text-white px-5 py-2 rounded-lg shadow hover:bg-red-700 transition"
          >
            Log Out
          </button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {categories.map(({ name, path, icon }) => (
            <div
              key={name}
              onClick={() => handleClick(path)}
              className="bg-white rounded-xl shadow-md p-6 cursor-pointer hover:bg-blue-50 hover:shadow-lg transition text-center border border-gray-200"
            >
              <div className="flex justify-center mb-2">{icon}</div>
              <h2 className="text-lg font-semibold text-blue-800">{name}</h2>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default Home;
